import { render, staticRenderFns } from "./EditXNusantaraModal.vue?vue&type=template&id=12921182&"
import script from "./EditXNusantaraModal.vue?vue&type=script&lang=js&"
export * from "./EditXNusantaraModal.vue?vue&type=script&lang=js&"
import style0 from "./EditXNusantaraModal.vue?vue&type=style&index=0&id=12921182&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports